import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'
import { getUser, getIsAuth } from '../../reducers/user'
import { fetchMe } from '../../actions/user'
import LoadingSpinner from '../LoadingSpinner'

const mapStateToProps = (state) => {
  return {
    user: getUser(state),
    isAuth: getIsAuth(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchMe() {
      return dispatch(fetchMe())
    },
  }
}

@connect(
  mapStateToProps,
  mapDispatchToProps,
)
class PrivateRoute extends Component {
  componentDidMount() {
    if (!this.props.user) {
      this.props.fetchMe()
    }
  }

  render() {
    const {
      user, isAuth, component: ChildComponent, ...rest
    } = this.props
    return (
      <Route
        {...rest}
        render={(props) => {
          if (isAuth === null) {
            return <LoadingSpinner />
          }
          return user ? <ChildComponent {...props} /> : <Redirect to="/login" />
        }}
      />
    )
  }
}

PrivateRoute.propTypes = {
  user: PropTypes.object,
  isAuth: PropTypes.any,
  component: PropTypes.any,
  fetchMe: PropTypes.func,
}

export default PrivateRoute
